export const RECRUITMENT_REQUEST_TIMELINE_RECORD_TYPE = 'RECRUITMENT_REQUEST';
export const POOL_TIMELINE_RECORD_TYPE = 'POOL';

export const isRecruitmentRequestTimelineEntry = (entry) => {
  const recordType = entry?.record_type ?? entry?.recordType;
  return recordType === RECRUITMENT_REQUEST_TIMELINE_RECORD_TYPE;
};

export const isPoolTimelineEntry = (entry) => {
  const recordType = entry?.record_type ?? entry?.recordType;
  return recordType === POOL_TIMELINE_RECORD_TYPE;
};

export const excludeRecruitmentRequestTimelineEntries = (timelineData = []) =>
  (Array.isArray(timelineData) ? timelineData : []).filter(
    (entry) => !isRecruitmentRequestTimelineEntry(entry),
  );

/** Pool activity belongs in the pool drawer, not company-wide feeds. */
export const excludePoolTimelineEntries = (timelineData = []) =>
  (Array.isArray(timelineData) ? timelineData : []).filter(
    (entry) => !isPoolTimelineEntry(entry),
  );

export const excludeScopedTimelineEntries = (timelineData = []) =>
  excludePoolTimelineEntries(excludeRecruitmentRequestTimelineEntries(timelineData));
